module.exports = __webpack_public_path__ + "img/car.d09069e7.png";